<template>
  <div class="layout">
    <app-header class="layout__header" />
    <div class="layout__body">
      <p
        v-if="hasTitle"
        class="layout__title"
        :class="{ 'layout__title--flipped': hasFlippedTitle }"
      >
        <strong
          class="layout__title__registration"
          v-text="i18n('teamRegistrationSite.registration')"
        />
        <span
          class="layout__title__separator"
          v-html="'&nbsp;'"
        />
        <span
          class="layout__title__name"
          v-text="name"
        />
      </p>
      <div class="layout__content">
        <router-view />
      </div>
    </div>
    <app-footer class="layout__footer" />
  </div>
</template>

<script>
import { i18n } from '@shared/i18n'

import { mapGetters, mapState } from 'vuex'

import AppHeader from '@/components/Header.vue'
import AppFooter from '@/components/Footer.vue'

export default {
  name: 'appLayout',
  data() {
    return {
      i18n,
    }
  },
  computed: {
    ...mapGetters('layout', ['language']),
    ...mapState('form', ['currentStep']),
    ...mapState('tournament', ['name', 'pageTitle']),
    hasTitle() {
      if (!this.$route) return false
      const { name: routeName } = this.$route
      if (routeName !== 'teamRegistration') return false
      if (this.currentStep === 6) return false
      return true
    },
    hasFlippedTitle() {
      const flippedTitleLanguages = ['en']
      return flippedTitleLanguages.includes(this.language)
    },
  },
  mounted() {
    document.title = this.pageTitle[this.language]
  },
  components: {
    AppFooter,
    AppHeader,
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,600,700&display=swap');

@import '~@shared/styles/theme/default.css';

@import '~@shared/styles/reset.css';
@import '~@shared/styles/layout.css';
@import '~@shared/styles/form.css';
@import '~@shared/styles/element-ui.css';
@import '~@shared/styles/icons.css';
@import '~@shared/styles/loading.css';

@import '~@/styles/transitions.scss';

.layout {
  --header-height: 72px;
  --footer-height: 48px;

  --content-margin-bottom: 16px;
  @include tablet { --content-margin-bottom: 32px; }

  --content-margin-top: 24px;
  @include tablet { --content-margin-top: 40px; }

  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh !important;
  height: 100vh;
  background-color: #f5f5f5;
  color: #333333;
  padding: 0;
  overflow: auto;
  overflow-x: hidden;

  * {
    word-break: break-word;
  }

  &__header {
    height: var(--header-height);
  }

  &__title {
    font-size: 22px;
    letter-spacing: -0.3px;
    color: #4c4c4c;
    text-transform: uppercase;
    display: flex;
    margin-bottom: 16px;
    justify-content: center;
    padding: 0;

    &__registration { order: 0; }
    &__separator { order: 1; }
    &__name { order: 2; }

    @include tablet {
      padding: 0 8px;
      margin-bottom: 32px;
      justify-content: flex-start;
    }

    @include desktop {
      padding: 0;
    }

    &--flipped {
      .layout__title__registration { order: 2; }
      .layout__title__name { order: 0; }
    }
  }

  &__footer {
    height: var(--footer-height);
  }

  &__body {
    min-height: calc(100vh - var(--header-height) - var(--footer-height) - var(--content-margin-top) - var(--content-margin-bottom));
    margin: var(--content-margin-top) 8px var(--content-margin-bottom);

    @include tablet {
      max-width: 736px;
      margin: var(--content-margin-top) auto var(--content-margin-bottom);
    }
  }

  &__content {
    position: relative;
    width: auto;
    max-width: 100%;   
    padding: 16px 16px 24px 16px;
    background-color: #ffffff;
    height: auto;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

    @include tablet {
      max-width: 736px;
    }

    @include desktop {
      max-width: 960px;
    }

    &__i18n {
      position: absolute;
      right: 16px;
      top: 16px;
    }
  }

  .el-checkbox__label {
    padding-left: 8px;

    @include tablet {
      padding-left: 10px;
    }
  }

  .el-checkbox__inner {
    width: 20px;
    height: 20px;

    &::after {
      border: 2px solid #ffffff;
      border-left: 0;
      border-top: 0;
      width: 5px;
      height: 11px;
      top: 0;
      left: 5px;
    }
  }

  .el-dialog {
    width: 300px;

    @include tablet {
      width: 400px;
    }

    @include desktop {
      width: 500px;
    }

    .custom-alert__contain {
      padding: 24px 16px;

      @include tablet {
        padding: 48px 80px;
      }
    }
  }
}
</style>
